import PIECE_TYPES from '../pieceTypes';

export class PieceTypeModel {
  /**
     *
     * @param type
     * @param alias
     */
  constructor(type = Number(), alias = String()) {
    this.type = type;
    this.alias = alias;
  }

  /**
     *
     * @param type
     * @returns {PieceTypeModel}
     */
  static createPieceTypeModel(type = Number()) {
    if (type === PIECE_TYPES.NonDocuments) {
      return new PieceTypeModel(type, 'NonDocuments');
    }
    return new PieceTypeModel(PIECE_TYPES.Documents, 'Documents');
  }
}

export default PieceTypeModel;
